import { Divider, MenuItem } from "@mui/material";
import { Dropdown } from "components/Dropdown";
import React from "react";
import PropTypes from "prop-types";
import { styled } from "@mui/material/styles";

export const AggregateDropdown = ({ granularity, onChange }) => {
  return (
    <MinWidthDropdown
      size="small"
      label="Aggregation"
      value={granularity}
      onChange={e => onChange(e.target.value)}
    >
      <MenuItem value="raw">Raw</MenuItem>
      <MenuItem value="day">Day</MenuItem>
      <MenuItem value="week">Week</MenuItem>
      <MenuItem value="month">Month</MenuItem>
      <DividerWithMargin />
      <MenuItem value="last_7_days">Last 7 days</MenuItem>
      <MenuItem value="last_30_days">Last 30 days</MenuItem>
    </MinWidthDropdown>
  );
};

AggregateDropdown.propTypes = {
  granularity: PropTypes.string,
  onChange: PropTypes.func
};

const MinWidthDropdown = styled(Dropdown)`
  min-width: 150px;
`;

const DividerWithMargin = styled(Divider)`
  margin: ${props => props.theme.spacing(1)} 0;
`;
